// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"6a89fe72","787":"9efaf7e5"}[chunkId] + ".chunk.js";
};